import {ClassicType} from "./ClassicType";

export class Dashboard {
  num_sped: number;
  totale:string;
  margine:string;
  spese:string;
  ins_cliente:string;
  ins_corriere:string;
  sped_corrieri: ClassicType[];
  imp_corrieri: ClassicType[];
  costi: ClassicType[];
  resoconto: any[];
}
export class DefaultChartElement{
  label: string;
  value: number | number;
}
